import { ContestantUserBaseModel, ContestantUserModel } from 'API/Generated/data-contracts';
import { GetContestantStore } from 'SessionState/Contestant/ContestantStore';
import { GetUserStore } from 'SessionState/User/UserStore';
import { Formik, Form } from 'formik';
import React, { useState, useEffect } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import AddEditContestantForm from 'views/users/contestants/components/AddEditContestantForm';
import * as Yup from 'yup';
import { IImage } from 'views/components/ImageUpload';
import { useHistory } from 'react-router-dom';
import userEvent from '@testing-library/user-event';


interface AddEditContestantModalProps {
  addEditContestantModal: boolean;
  setAddEditContestantModal: (addEditContestantModal: boolean) => void;
  contestant: ContestantUserModel | undefined;
}

interface IAddEditContestantValues extends ContestantUserBaseModel, IImage {
}

const AddEditContestantModal = (props: AddEditContestantModalProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const contestantStore = GetContestantStore();
  const userStore = GetUserStore();


  const otherValidationSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    genderId: Yup.number().required('Gender is Required'),
    martialStatusId: Yup.number(),
    hairColor: Yup.string(),
    eyeColor: Yup.string(),
    birthday: Yup.string().required(),
    city: Yup.string().required(),
    stateId: Yup.number().required("State is Required"),
    // about: Yup.string(),
    hobbies: Yup.string(),
    // industryStyleTypeIds: Yup.array().of(Yup.number()).min(1)
  });
  const initialValues: IAddEditContestantValues = {
    firstName: props.contestant?.firstName ?? '',
    lastName: props.contestant?.lastName ?? '',
    genderId: props.contestant?.genderId ?? -1,
    martialStatusId: props.contestant?.martialStatusId ?? 1,
    hairColor: props.contestant?.hairColor ?? '',
    eyeColor: props.contestant?.eyeColor ?? '',
    birthday: props.contestant?.birthday ?? '',
    // dateStartedCompeting: props.contestant.dateStartedCompeting ?? '',
    city: props.contestant?.city ?? '',
    stateId: props.contestant?.stateId ?? null,
    // aboutMeId: props.contestant?.aboutMeId ?? '',
    hobbies: props.contestant?.hobbies ?? '',
    // competitionStatus: props.contestant.competitionStatus ?? '',
    // teamStatus: props.contestant.teamStatus ?? '',
    industryStyleTypeIds: props.contestant?.industryStyleTypeIds ?? [],
    // profilePicture: props.contestant?.profilePicture ?? new Uint8Array()
    userId: props.contestant?.userId ?? userStore.CurrentUser?.id ?? 0,
    profilePic: props.contestant?.profilePic ?? { id: 0, image: '', imageName: '', imageType: '' },
    image: {
      id: props.contestant?.profilePic?.id ?? 0,
      image: props.contestant?.profilePic?.image ?? '',
      imageName: props.contestant?.profilePic?.imageName ?? '',
      imageType: props.contestant?.profilePic?.imageType ?? ''
    }
  };

  const [triggerGoToContestants, setTriggerGoToContestants] = useState(false);
  const navigate = useHistory();



  const saveContestent = (values: IAddEditContestantValues, reset) => {
    setIsLoading(true);
    console.log(values);
    values.profilePic = {...values?.image}
    contestantStore.saveContestant(values).then((success) => {
      if (success) {
        toast.success('New Contestant Member Add to your Account Successfully');
        setIsLoading(false);
        // userStore.setLoggedInUser();
        userStore.refreshCurrentUser();
        props.setAddEditContestantModal(false);
        setTriggerGoToContestants(success);
        // navigate.push(`/my-contestants`);
        //  userStore.refreshCurrentUser();
        reset();
      } else {
        toast.error('Error Saving Contestant Profile');
        setIsLoading(false);
      }
    });
  };



  useEffect(() => {}, [contestantStore.getContestants]);
  
  // useEffect(() => {
  //   if (triggerGoToContestants) {
  //     navigate.push(`/my-contestants`);
  //     setTriggerGoToContestants(false);
  //   }
  // }, [triggerGoToContestants]);



  return (
    <Modal className=" modal-right large fade" show={props.addEditContestantModal} onHide={() => props.setAddEditContestantModal(false)}>
      <Formik initialValues={initialValues} validationSchema={otherValidationSchema} onSubmit={(values, { resetForm }) => {
        saveContestent(values, resetForm)
      }}>
        {({ values, resetForm, handleChange, setFieldValue }) => (
          <Form>
            <Modal.Header>
              <Modal.Title>Create A Contestants Profile on your Account</Modal.Title>
            </Modal.Header>
            <Modal.Body>
           {/* {userStore.CurrentUser?.contestantUserAccounts?.length ?? 0 <= 0 ?  <em className='text-danger'>We noticed you have no contestant profiles created on your account, add one now below!</em> : null} */}
              <AddEditContestantForm contestant={props.contestant} contestantIndex={0} />
            </Modal.Body>
            <Modal.Footer className='position-absolute w-100 bottom-0'>
              <Button variant="outline-primary" onClick={() => { props.setAddEditContestantModal(false); resetForm(); }}>
                Cancel
              </Button>
              <Button type="submit" disabled={isLoading}>{isLoading ? <Spinner as="span" animation="border" size="sm" /> : 'Save Contestant'}</Button>
            </Modal.Footer>
          </Form>)}
      </Formik>
    </Modal>
  );
};

export default AddEditContestantModal;